module.exports = __webpack_public_path__ + "img/pengajuan-bimbingan.0bba22fe.png";